module.exports = "/_next/static/images/OneAudience@2x-b19c96e5855ab38bb127cfc1a2907c16.webp";